/* DSL Order-bot — push updates wanneer order-status wijzigt; vereist app-proxy /apps/dsl/orders/{id} */
(function(){
  if (location.pathname.indexOf("/orders/") !== 0) return;
  var slot = document.querySelector("[data-order-status-live]");
  if (!slot) return;
  var oid = slot.dataset.orderId;
  var lastStatus = slot.dataset.currentStatus;
  setInterval(function(){
    fetch("/apps/dsl/orders/" + oid).then(function(r){return r.json();}).then(function(d){
      if (d.status && d.status !== lastStatus) {
        if (window.DSL_BANNER) window.DSL_BANNER.show({text: "📦 Bestelling-status: " + d.status, variant: "info", duration: 8000});
        slot.textContent = d.status;
        lastStatus = d.status;
      }
    }).catch(function(){});
  }, 30000);
})();